export default __webpack_public_path__ + "static/media/bitcoin-btc-logo.6c2ee359.svg";